<template>
  <div class="hashtag">
    <div
      v-if="title"
      class="hashtag__title"
      :class="{ hashtag__title_wide: title.text.length > 15 }"
      data-animation="fadeInBottom"
    >
      <BaseTitle v-bind="title" />
    </div>
    <IconButton
      v-if="hasCloseButton"
      icon="cross"
      theme="light"
      view="outlined"
      @click="close"
      class="hashtag__close"
    />
    <div v-if="timerDuration > 0" class="hashtag__timer">
      <BaseTimer
        ref="timer"
        :duration="timerDuration"
        @finish="close"
      />
    </div>
  </div>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import IconButton from '@/components/IconButton.vue';
import BaseTimer from '@/components/BaseTimer.vue';

export default {
  name: 'Hashtag',
  components: {
    BaseTitle,
    IconButton,
    BaseTimer,
  },
  props: {
    title: {
      type: Object,
      default: null,
    },
    timerDuration: {
      type: Number,
      default: 60,
    },
    hasCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    startTimer() {
      return this.$refs.timer?.start();
    },
    stopTimer() {
      return this.$refs.timer?.stop();
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="stylus">
.hashtag
  display flex
  align-items center
  justify-content center
  color $c_light

  &__title
    font-size 5em
    &_wide
      font-size 3.5em

  &__timer
  &__close
    margin 1em
    z-index 10

  &__timer
    abs top left

  &__close
    abs top right
    color inherit
    opacity 0.5
    &:hover
      opacity 1
</style>
